import React from 'react'
import FormFactory from '../../../../../components/form/form-factory'
import AssessmentForm from './assessment-form'
import IFormPage from '../../../../../interfaces/form-page'

import {
  Container,
  ContentWrapper,
  Title,
} from './styles'
import Guide from '../../../../../components/guide'

type IProps = any & IFormPage

const AssessmentEditor = ({
  dataForm,
  initialAssessmentsData,
  setData,
  assessmentDataForm,
  onSubmit,
  initialData,
  isToUpdate = false,
}: IProps) => (
  <Container>
    <ContentWrapper>
      <div>
        <Title>Configure o formato desejado para avalição final do cliente</Title>
        <FormFactory
          data={dataForm}
          onSubmit={onSubmit}
          setData={setData}
          initialData={initialAssessmentsData}
        />

        <Title>Perguntas na tela de avaliação</Title>
        <AssessmentForm
          dataForm={assessmentDataForm}
          onSubmit={onSubmit}
          initialData={initialData}
          isToUpdate={isToUpdate}
        />
      </div>
      <div>
        <Guide
          title="Orientações"
          instructions={[
            'Faça perguntas objetivas (Ex: Gostou do sistema de pedidos?)',
            'Para que usuário não canse de responder, adicione no máximo 4 perguntas',
            'É Possivel adicionar, editar e excluir as perguntas quando quiser',
          ]}
        />
      </div>
    </ContentWrapper>
  </Container>

)

export default AssessmentEditor
